

// =============================================
// File: src/services/discountService.js
// =============================================

import axiosInstance from "./axiosInstance";


  // Get all discounts
  export const getDiscounts = async (params = {}) => {
    try {
      const response = await axiosInstance.get('/discounts', { params });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get single discount by ID
  export const getDiscountById =  async (id) => {
    try {
      const response = await axiosInstance.get(`/discounts/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Create new discount
  export const createDiscount =  async (discountData) => {
    try {
      const response = await axiosInstance.post('/discounts', discountData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Update discount
  export const updateDiscount= async (id, discountData) => {
    try {
      const response = await axiosInstance.put(`/discounts/${id}`, discountData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Delete discount
  export const deleteDiscount= async (id) => {
    try {
      const response = await axiosInstance.delete(`/discounts/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Validate discount code
  export const validateDiscountCode = async ({companyId,code, orderAmount}) => {
    try {
      const response = await axiosInstance.post('/discounts/validate', { 
        code, 
        orderAmount ,
        companyId
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Apply discount to order
  export const applyDiscount = async (orderId, discountCode) => {
    try {
      const response = await axiosInstance.post('/discounts/apply', { 
        orderId, 
        discountCode 
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get discount usage statistics
 export const getDiscountStats = async (id) => {
    try {
      const response = await axiosInstance.get(`/discounts/${id}/stats`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Activate/Deactivate discount
  export const toggleDiscountStatus = async (id, status) => {
    try {
      const response = await axiosInstance.patch(`/discounts/${id}/status`, { status });
      return response;
    } catch (error) {
      throw error;
    }
  }



